module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.applists), function(item) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box",
      on: {
        "click": function($event) {
          _vm.goToApp(item.appid, item.appname, item.UidPermission)
        }
      }
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [(item.appicon == '') ? _c('img', {
      staticClass: "app-list-img",
      attrs: {
        "src": require("../../../static/img/img_app_list_icon_default.png")
      }
    }) : _c('img', {
      staticClass: "app-list-img",
      attrs: {
        "src": 'https://d.din.bz/' + item.appicon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(item.appname))]), _vm._v(" "), _vm._m(0, true)])])])
  }), 0)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: 'addapp',
        query: {
          appname: 'Add App'
        }
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticClass: "add-app-bgcolor"
  }, [_c('span', {
    staticClass: "btn add-app pull-right"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "go-to-app"
  }, [_vm._v("\n              Go To\n              "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2628c90d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2628c90d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Project.vue
// module id = 460
// module chunks = 1